// // import Swiper core and required modules
// import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

// import { Swiper, SwiperSlide } from 'swiper/react';

// // Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

// import CardReview from './Card/CardReview';

// export default function SwiperComp() {
//   return (
//     <Swiper
//       // install Swiper modules
//       modules={[Navigation, Pagination, A11y]}
//       spaceBetween={50}
//       slidesPerView={3}
//       navigation
//       pagination={{ clickable: true }}
//       // scrollbar={{ draggable: true }}
//       onSwiper={(swiper) => console.log(swiper)}
//       onSlideChange={() => console.log('slide change')}>
//       <div className="grid grid-cols-3">
//         <SwiperSlide>
//           <CardReview />
//         </SwiperSlide>
//         <SwiperSlide>
//           <CardReview />
//         </SwiperSlide>
//         <SwiperSlide>
//           <CardReview />
//         </SwiperSlide>
//         <SwiperSlide>
//           <CardReview />
//         </SwiperSlide>
//       </div>
//     </Swiper>
//   );
// }

import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

// import "./styles.css";

// import required modules
import { EffectCoverflow, Pagination } from 'swiper';

import CardReview from './Card/CardReview';

export default function App() {
  return (
    <>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={3}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper">
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
        <SwiperSlide>
          <CardReview />
        </SwiperSlide>
      </Swiper>
    </>
  );
}
